<template>
  <div class="bend">
    <b-container style="height:100%;">
      <div class="bendwrapper">
        <div class="bendmenu">해당학습내의 밴드</div>
        <div class="bendmenu">
          #1
          <div class="bar"></div>
        </div>
        <div class="bendmenu">#2</div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.bend {
  height: 50px;
  background-color: white;
}
.bendwrapper {
  height: 100%;
  display: flex;
  //   justify-items: center;
  //   align-content: center;
  //   align-items: center;
  .bendmenu {
    display: inline-flex;
    justify-items: center;

    line-height: 50px;
    padding: 0 15px 0 15px;
    margin-right: 45px;
    position: relative;
    height: 100%;
    font-family: $font;
    .bar {
      position: absolute;
      width: 100%;
      border-bottom: 5px solid $point1;
      left: 0;
      bottom: 0;
    }
  }
}
</style>